// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const PdfFileIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PdfFile",
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.65 19.81v-1.12c-.02-.96-.8-1.73-1.76-1.74h-.1v4.68h.1a1.78 1.78 0 0 0 1.76-1.78v-.03Zm-6.26-1.03c.36 0 .65-.29.65-.65v-.57a.655.655 0 0 0-.65-.61H6.17v1.87h1.22zm-.28 5.61v1.87c0 2.2 1.73 3.74 4.21 3.74h14.02c2.48 0 4.21-1.54 4.21-3.74V10.54c-.03-.12-.07-.24-.12-.34s0-.07 0-.07c-.06-.12-.14-.21-.22-.3l-7.54-7.5c-.09-.09-.19-.16-.3-.22s-.08 0-.08 0c-.08-.04-.17-.07-.27-.1s-9.69 0-9.69 0c-2.3 0-4.17 1.85-4.21 4.14v7.96H4.31c-1.03 0-1.87.84-1.87 1.87v6.55c0 1.03.84 1.87 1.87 1.87h2.81Zm0-8.42h.28c.88 0 1.59.71 1.59 1.59v.57c0 .88-.71 1.59-1.59 1.59H6.17v2.34a.49.49 0 0 1-.98 0v-5.61c0-.26.21-.47.47-.47H7.1Zm13.1.47c0 .26-.21.47-.47.47H17.4v1.87h2.34a.49.49 0 0 1 0 .98H17.4v2.34a.49.49 0 0 1-.98 0v-5.65c0-.26.21-.47.47-.47h2.85c.26 0 .47.21.47.47Zm-5.58 2.25v1.12c0 1.49-1.22 2.7-2.71 2.71h-.6a.47.47 0 0 1-.47-.47v-5.61c0-.26.21-.47.47-.47h.58c1.5 0 2.72 1.22 2.72 2.72ZM9.92 6.15c0-.77.63-1.4 1.4-1.4h7.95V9.9c0 1.29 1.05 2.34 2.34 2.34h5.15v14.03c0 .77-.76.97-1.4.97H11.33c-.64 0-1.4-.17-1.4-.97V24.4h11.23c1.03 0 1.87-.84 1.87-1.87v-6.55c0-1.03-.84-1.87-1.87-1.87H9.93V6.16Z"
    })
  });
};